// @flow
import React, { Component, Fragment } from 'react';
import { Label, FormGroup, InputGroup } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import Responsive from 'react-responsive';

import withFlightSearchParams from '../../../HOCs/withFlightSearchParams';

import '../../../../node_modules/flatpickr/dist/themes/airbnb.css';

import type { UpdateFlightSearchParms } from '../flowTypes';

type Props = {
  updateFlightSearchParms: UpdateFlightSearchParms,
  searchParams: {
    trip_type: 'R' | 'O',
    departure_date: string,
    arrival_date: string,
  },
};

const getFormatedDate = date => moment(date).format('YYYY-MM-DD');
class DateInput extends Component<Props> {
  render() {
    const { trip_type, departure_date, arrival_date } = this.props.searchParams;
    const formattedDepartureDate = moment(departure_date).format('DD MMM YYYY');
    const formattedArrivalDate = moment(arrival_date).format('DD MMM YYYY');
    return (
      <Fragment>
        <Responsive minWidth={767}>
          <div className="row">
            <FormGroup className="col-12">
              <Label className="title">Departure Date:</Label>
              <InputGroup>
                <Flatpickr
                  className="form-control"
                  value={formattedDepartureDate}
                  options={{
                    minDate: 'today',
                    allowInput: false,
                    disableMobile: true,
                    dateFormat: 'd M Y',
                    defaultDate: formattedDepartureDate,
                  }}
                  onChange={val => this.handleDateChange(val, 'departure')}
                  placeholder="Select Departure Date"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup className="col-12">
              {trip_type === 'O' && (
                <Fragment>
                  <Label className="title" style={{ opacity: 0 }}>
                    Return Date:
                  </Label>
                  <input
                    disabled
                    className="form-control"
                    placeholder="YYYY-MM-DD"
                    style={{ opacity: 0 }}
                  />
                </Fragment>
              )}
              {trip_type === 'R' && (
                <Fragment>
                  <Label className="title">Return Date:</Label>
                  <InputGroup>
                    <Flatpickr
                      className="form-control"
                      value={formattedArrivalDate}
                      options={{
                        minDate: formattedDepartureDate,
                        allowInput: false,
                        disableMobile: true,
                        dateFormat: 'd M Y',
                        defaultDate: formattedArrivalDate,
                      }}
                      onChange={val => this.handleDateChange(val, 'arrival')}
                      placeholder="Select Return Date"
                    />
                  </InputGroup>
                </Fragment>
              )}
            </FormGroup>
          </div>
        </Responsive>
        {/* ========================================= DATE PICKER FOR MOBILE ===================================== */}
        <Responsive maxWidth={767}>
          <div className="row">
            <FormGroup className="col-12">
              <Label className="title">Departure Date:</Label>
              <InputGroup>
                <Flatpickr
                  className="form-control"
                  value={formattedDepartureDate}
                  options={{
                    minDate: 'today',
                    disableMobile: true,
                    dateFormat: 'd M Y',
                    defaultDate: formattedDepartureDate,
                  }}
                  onChange={val => this.handleDateChange(val, 'departure')}
                  placeholder="Select Departure Date"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup className="col-12">
              {trip_type === 'R' && (
                <Fragment>
                  <Label className="title">Return Date:</Label>
                  <InputGroup>
                    <Flatpickr
                      className="form-control"
                      value={formattedArrivalDate}
                      options={{
                        disableMobile: true,
                        dateFormat: 'd M Y',
                        disable: [date => moment(date).isBefore(moment(departure_date))],
                        defaultDate: formattedArrivalDate,
                      }}
                      onChange={val => this.handleDateChange(val, 'arrival')}
                      placeholder="Select Return Date"
                    />
                  </InputGroup>
                </Fragment>
              )}
            </FormGroup>
          </div>
        </Responsive>
      </Fragment>
    );
  }

  handleDateChange = (value, key) => {
    const { updateFlightSearchParms } = this.props;
    const date = getFormatedDate(value[0]);

    if (key === 'departure') {
      updateFlightSearchParms({ parameter: 'departure_date', value: date });
    } else {
      updateFlightSearchParms({ parameter: 'arrival_date', value: date });
    }
  };
}

export default withFlightSearchParams(DateInput);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/DatePicker.jsx